import { Bar } from 'vue-chartjs'
import { formatValue } from '@/lib/kpi-data'

export default {
  name: 'KPIBarChart',
  extends: Bar,
  props: {
    chartData: { type: Object, required: true },
    format: { type: String, required: true },
    /** Quando true (ex.: CAC, CPL, Espera), realizado > meta = vermelho; realizado <= meta = verde */
    lowerIsBetter: { type: Boolean, default: false },
    /** Quando false, oculta meta e qualquer comparação (somente Realizado) */
    showMeta: { type: Boolean, default: true },
    /** Rótulo do dataset do realizado (legenda/tooltip) */
    realizadoLabel: { type: String, default: 'Realizado' },
  },
  mounted() {
    this.render()
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.render()
      },
    },
  },
  methods: {
    render() {
      const data = this.chartData
      const metaArr = Array.isArray(data?.meta) ? data.meta : []
      const realizadoArr = Array.isArray(data?.realizado) ? data.realizado : []

      const realizadoColors = realizadoArr.map((v, idx) => {
        const realizado = Number(v || 0)
        const meta = Number(metaArr[idx] || 0)
        if (!this.showMeta) {
          return '#000000' // azul fixo quando não há meta
        }
        // lowerIsBetter (CAC, CPL): passar da meta = vermelho; dentro ou abaixo = verde
        if (this.lowerIsBetter) {
          return realizado >= meta ? '#ef4444' : '#22c55e'
        }
        // Padrão: verde quando atingiu ou passou a meta; vermelho caso contrário
        return realizado >= meta ? '#22c55e' : '#ef4444'
      })

      const datasets = []
      if (this.showMeta) {
        datasets.push({
          label: 'Meta',
          backgroundColor: '#000000',
          data: data.meta,
          datalabels: {
            display: true,
            color: 'white',
            anchor: 'center',
            align: 'center',
            rotation: -90,
            font: { size: 10, weight: '600' },
            formatter: (value) => formatValue(value, this.format),
            clamp: true,
          },
        })
      }
      datasets.push({
        label: this.realizadoLabel || 'Realizado',
        backgroundColor: realizadoColors,
        borderColor: realizadoColors,
        borderWidth: 1,
        // Quando o realizado é muito menor que a meta (ex: 200 vs 300k),
        // o bar fica praticamente invisível. Isso garante um mínimo visual.
        minBarLength: 3,
        data: data.realizado,
        datalabels: {
          // Mostra label apenas quando tiver valor (evita poluir com zeros)
          display: (ctx) => Number(ctx.dataset.data[ctx.dataIndex] || 0) !== 0,
          color: 'white',
          anchor: 'center',
          align: 'center',
          rotation: -90,
          font: { size: 10, weight: '600' },
          formatter: (value) => formatValue(value, this.format),
          clamp: true,
        },
      })

      this.renderChart(
        {
          labels: data.labels,
          datasets,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: 'bottom',
            labels: { boxWidth: 12, padding: 12 },
          },
          layout: {
            padding: { top: 8, right: 8, bottom: 8, left: 8 },
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, chart) => {
                const datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || ''
                const v = tooltipItem.yLabel
                return `${datasetLabel}: ${formatValue(v, this.format)}`
              },
            },
          },
          scales: {
            xAxes: [
              {
                gridLines: { display: false },
                stacked: false,
                ticks: { autoSkip: true, maxTicksLimit: 6, maxRotation: 0, minRotation: 0 },
              },
            ],
            yAxes: [{ stacked: false, ticks: { beginAtZero: true } }],
          },
        },
      )
    },
  },
}

